import request from '../request/http.js'
//通用接口
export function auth(url,data) {
    return request({
        url: url,
        method: 'post',
        data: data,
    })
}
export function anth(url,data) {
    return request({
        url: url,
        method: 'get',
        data: data,
    })
}
// 登录
export function login(data) {
    return request({
        // url:'/member/login/login',
        // url:'/v1/member/login/login',
        // url:"/v1/member/login/sms_login",
        url:'v1/member/login/new_sms_login',
        method : "post" ,
        data:data,
    })
}
export function loginauth(data) {
    return request({
        url:'/v1/member/user/auth_list',
        method : "post" ,
        data:data,
    })
}

// 登出

export function logout() {
    return request({
        url:'/member/login/loginOut',
        method : "post"
    })
}

// 个人信息
export function getInfo() {
    return request({
        // url:'/member/login/userInfo',
        url:'/v1/member/user/getInfo',
        method :"post"
    })
}
